import BookingForm from "../../components/bookingForm/BookingForm"
import SliderLeft from "../../components/events/slider/SliderLeft"
import SliderRight from "../../components/events/slider/SliderRight"
import Section3 from "../../components/home/section-3/Section3"
import { useEffect, useState } from "react";
import EventService from "../../services/api/event.service";
import isEmpty from "../../utils/isempty.utils";
import { ICardEventAdmin, IImage } from "../../models/component/ICardEventAdmin";
import GalerieService from "../../services/api/galerie.service";




const Events = () => {
  const [arrayCardEvent, setArrayCardEvent] = useState<ICardEventAdmin[]>([]);
  const [arrayGalleryImagesLeft, setArrayGalleryImagesLeft] = useState<string[]>([]);
  const [arrayGalleryImagesRight, setArrayGalleryImagesRight] = useState<string[]>([]);

  useEffect(() => {
    fetchAllEvents();
    fetchAllImagesGalerie()
  }, []);

  function isEven(num: number): boolean {
    return num % 2 === 0;
  }

  function extractAndPrefixUris(images: IImage[], prefix: string): string[] {
    return images
      .filter(image => image.uri !== undefined) // Filtrer les images avec une URI définie
      .map(image => prefix + image.uri); // Ajouter le préfixe à chaque URI
  }

  const fetchAllEvents = () => {
    EventService.getAllEvents()
      .then((r) => {
        if (!isEmpty(r.data) && !isEmpty(r.data[0].images)) {
          setArrayCardEvent(r.data);
        } else {
          setArrayCardEvent([]);
        }
      })
      .catch((error) => console.error(error));
  };

  const fetchAllImagesGalerie = () => {
    const arrayGaleri:string[] = []
    GalerieService.getAll()
      .then((r) => {
        if (!isEmpty(r.data)) {
          r.data.images.map((value) => {
            arrayGaleri.push(`https://api.leblr.fr${value.uri}`)
          })
          setArrayGalleryImagesLeft(arrayGaleri);
          setArrayGalleryImagesRight(arrayGaleri);
        } else {
          setArrayCardEvent([]);
        }
      })
      .catch((error) => console.error(error));
  };
  
  return (
    <div className="view-events">
      <div className="container-title">
        <div className="title">Galerie & Evenements</div>
      </div>
      <div className="container-events">
        {
          !isEmpty(arrayCardEvent) ? (
            arrayCardEvent.map((value, index) =>
              <Section3 images={extractAndPrefixUris(value.images,"https://api.leblr.fr")}
                title={""}
                left={isEven(value.id)}
                key={index}
                linkButton={"events"}
                titleButton={"Événements"}
                paragraph={value.description}
                titleExplain={value.name}
                buttonActive={false}/>
            )
          ) : (
            <div></div>
          )
        }
      </div>
      <div className="container-galerie">
        <div className="title-galerie">Galerie</div>
        <SliderRight images={arrayGalleryImagesLeft}/>
        <SliderLeft images={arrayGalleryImagesRight}/>
      </div>
      <div className="container-galerie mobile">
        <div className="title-galerie">Galerie</div>
        <SliderRight images={arrayGalleryImagesLeft}/>
        <SliderLeft images={arrayGalleryImagesRight}/>
      </div>
      <BookingForm/>
    </div>
  )
}

export default Events
